// JournalArticleForm migration: 1.2 Article — wire journalArticleRecordSchema into schema factory
import { bookSchema } from '@content-registration/content-types/book/book-schemas';
import { conferenceProceedingRecordSchema } from '@content-registration/content-types/conference-proceeding/conference-proceeding-schemas';
import { postPublicationUpdateRecordSchema } from '@content-registration/content-types/post-publication-update/post-publication-update-schemas';
import { dissertationRecordSchema } from '@content-registration/content-types/dissertation/dissertation-schemas';
import { grantRecordSchema } from '@content-registration/content-types/grant/grant-schemas';
import { reportRecordSchema } from '@content-registration/content-types/report/report-schemas';
import { journalArticleRecordSchema } from '@content-registration/content-types/journal-article/journal-article-schemas';
import {
  ContentRegistrationFormSchema,
  ContentRegistrationType,
} from '@/common/types';

/**
 * Returns the JSON Schema for a specified form type.
 *
 * @param {ContentRegistrationType} formType - The form type to retrieve the jsonSchema for.
 * @returns {JsonSchema} The corresponding JSON Schema.
 * @throws {Error} If no jsonSchema is found for the specified form type.
 */
export function getSchemaForFormType(
  formType: ContentRegistrationType
): ContentRegistrationFormSchema {
  switch (formType) {
    case ContentRegistrationType.Grant:
      return {
        title: 'Crossref Grant Schema',
        version: '1.0.0',
        schema: grantRecordSchema,
      };
    case ContentRegistrationType.JournalArticle:
      return {
        title: 'Crossref Journal Article Schema',
        version: '1.0.0',
        schema: journalArticleRecordSchema,
      };
    case ContentRegistrationType.Book:
      return {
        title: 'Crossref Book Schema',
        version: '1.0.0',
        schema: bookSchema,
      };
    case ContentRegistrationType.ConferenceProceeding:
      return {
        title: 'Crossref Conference Proceeding Schema',
        version: '1.0.0',
        schema: conferenceProceedingRecordSchema,
      };
    case ContentRegistrationType.PostPublicationUpdate:
      return {
        title: 'Crossref Post-Publication Update Schema',
        version: '1.0.0',
        schema: postPublicationUpdateRecordSchema,
      };
    case ContentRegistrationType.Dissertation:
      return {
        title: 'Crossref Dissertation Schema',
        version: '1.0.0',
        schema: dissertationRecordSchema,
      };
    case ContentRegistrationType.Report:
      return {
        title: 'Crossref Report Schema',
        version: '1.0.0',
        schema: reportRecordSchema,
      };
    default:
      throw new Error(`No schema found for form type: ${formType}`);
  }
}
